<srs-field *ngFor="let field of fields" [field]="field.searchField ? field.searchField : field" (triggerUpdateSearch)="onUpdateSearch()"></srs-field>
